import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { toast } from '../hooks/use-toast';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const navigate = useNavigate();

  const handleLogin = (e) => {
    e.preventDefault();
    
    // Mock login - check against mock users
    const mockUsers = JSON.parse(localStorage.getItem('mockUsers') || '[]');
    const user = mockUsers.find(u => u.email === email && u.password === password);
    
    if (user) {
      localStorage.setItem('user', JSON.stringify(user));
      
      // Track login session for online count
      const loginSessions = JSON.parse(localStorage.getItem('loginSessions') || '[]');
      loginSessions.push(Date.now());
      localStorage.setItem('loginSessions', JSON.stringify(loginSessions));
      
      toast({
        title: 'Başarılı!',
        description: 'Giriş başarılı.',
      });
      if (user.role === 'admin') {
        navigate('/admin');
      } else {
        navigate('/dashboard');
      }
    } else {
      toast({
        title: 'Hata!',
        description: 'Email veya şifre yanlış.',
        variant: 'destructive',
      });
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-black via-gray-900 to-black flex items-center justify-center px-4">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-green-900/20 via-transparent to-transparent"></div>
      
      <div className="relative z-10 w-full max-w-md">
        <div className="bg-gradient-to-br from-gray-900 to-black border border-green-500/30 rounded-2xl p-8 shadow-2xl shadow-green-500/10">
          <div className="text-center mb-8">
            <Link to="/" className="inline-flex items-center space-x-2 mb-4">
              <img src="/logo.webp" alt="Swenzy" className="w-12 h-12 rounded-lg" />
              <span className="text-2xl font-bold text-green-400">Swenzy</span>
            </Link>
            <h1 className="text-3xl font-bold text-white mt-4">Giriş Yap</h1>
            <p className="text-gray-400 mt-2">Hesabınıza erişin</p>
          </div>

          <form onSubmit={handleLogin} className="space-y-6">
            <div>
              <Label htmlFor="email" className="text-white">Email</Label>
              <Input
                id="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="mt-2 bg-gray-800 border-green-500/30 text-white focus:border-green-500"
                placeholder="ornek@email.com"
                required
              />
            </div>

            <div>
              <Label htmlFor="password" className="text-white">Şifre</Label>
              <Input
                id="password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="mt-2 bg-gray-800 border-green-500/30 text-white focus:border-green-500"
                placeholder="••••••••"
                required
              />
            </div>

            <Button
              type="submit"
              className="w-full bg-gradient-to-r from-green-500 to-green-600 hover:from-green-600 hover:to-green-700 text-black font-semibold py-3"
            >
              Giriş Yap
            </Button>
          </form>

          <div className="mt-6 text-center">
            <p className="text-gray-400">
              Hesabınız yok mu?{' '}
              <Link to="/register" className="text-green-400 hover:text-green-300 font-semibold">
                Kayıt Ol
              </Link>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;